import { CHAPTER_SUCCESS, CHAPTER_FAILURE } from '../actionType'

export const initialState = {
    chapters: [],
    loading: true,
    error: null,
    success: false,
}

export default function chapterReducer(state = initialState, action) {
  const { type, payload } = action
  switch (type) {   
    case CHAPTER_SUCCESS:
      return {
        chapters: payload,
        loading: false,
        error: false,
        success:true,
      }
    case CHAPTER_FAILURE:
      return {        
        loading: true,
        error: payload,
        success: false
      }
    default:
      return state
  }
}